const TENANT_BRA = 'ambev-hercules-autorizacao';
const TENANT_PREFIX = `${TENANT_BRA}-tenant-`;
/** Parte curta do tenant: `bra`, `bra-3pd`, `arg`, `mex`. */
export const getTenantShortName = (tenant) => {
    if (tenant === TENANT_BRA) {
        return 'bra';
    }
    return tenant.startsWith(TENANT_PREFIX)
        ? tenant.slice(TENANT_PREFIX.length)
        : tenant;
};
const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1);
/** Ex.: `Bra-3pd`. */
export const getTenantLabel = (tenant) => capitalize(getTenantShortName(tenant));
/**
 * Chave do título da opção, ex.: `Brasil - Ambev - CDD`. É o mesmo nome no
 * drawer de troca e no card do tenant atual no menu de perfil.
 */
export const getTenantOptionTitleKey = (option) => `drawerChangeTenant:option.${option.id}`;
/**
 * Partes da linha que descreve a opção: sem a zona
 * (`Realm: Ambev, Tenant: Bra`) ou, no drawer, com ela
 * (`Zona: SAZ, Realm: Third, Tenant: Bra-3pd`).
 */
export const getTenantOptionParts = (option, { withZone = false } = {}) => [
    withZone ? { label: 'Zona', value: option.zone } : null,
    { label: 'Realm', value: option.realm },
    { label: 'Tenant', value: getTenantLabel(option.tenant) },
].filter(Boolean);
/** Mesma linha em texto puro, ex.: `Zona: SAZ, Realm: Ambev, Tenant: Bra`. */
export const getTenantOptionDescription = (option, options = {}) => getTenantOptionParts(option, options)
    .map((part) => (part.label ? `${part.label}: ${part.value}` : part.value))
    .join(', ');
//# sourceMappingURL=tenant-option-description.js.map